export default "__VITE_ASSET__DpsJnvVv__"